import { baseApi } from "../../../api/baseApi.js";
import { prepareQueryParams } from "../../../helpers/index.js";

export const cartApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCartItems: build.query({
      query: (params) => {
        return {
          url: "/getcartitems",
          method: "GET",
          params: {
            adddamagefee: 1,
            promoCode: "",
            ...prepareQueryParams(params),
          },
        };
      },
      providesTags: ["Cart"],
    }),
    addCartItem: build.mutation({
      query: (payload) => {
        return {
          url: "/addcartitem",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: {
            ...prepareQueryParams(),
            ...payload,
          },
        };
      },
      invalidatesTags: ["Cart"],
    }),
  }),
});

export const {
  useGetCartItemsQuery,
  useAddCartItemMutation,
  useLazyGetCartItemsQuery: useLazyGetUpsellCartQuery,
} = cartApi;
